'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var _default = {
	container: {
		width: '100%',
		padding: '1.28em 0',
		minHeight: '14.43em',
		margin: '0 0 2em'
	},
	inner: {
		padding: '0 1.06em'
	},
	poolName: {
		fontWeight: '600',
		fontSize: '1em'
	},
	tableBodyText: {
		fontSize: '1em'
	},
	statsContainer: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'space-between',
		margin: '0 auto'
	}
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/styles/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageTalentPools/styles/index.js
// module id = 0Ajs
// module chunks = 62 63